import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron_right",
  "use": "icon-chevron_right-usage",
  "viewBox": "0 0 58 58",
  "content": "<symbol viewBox=\"0 0 58 58\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chevron_right\">\r\n<path d=\"M24.1654 16.2148C23.2229 17.1573 23.2229 18.6798 24.1654 19.6223L33.542 28.999L24.1654 38.3756C23.2229 39.3181 23.2229 40.8406 24.1654 41.7831C25.1079 42.7256 26.6304 42.7256 27.5729 41.7831L38.6654 30.6906C39.6079 29.7481 39.6079 28.2256 38.6654 27.2831L27.5729 16.1906C26.6545 15.2723 25.1079 15.2723 24.1654 16.2148Z\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol